export default __webpack_public_path__ + "static/media/4.12a2a4a1.jpg";